import { useRef } from 'react'

import { Tooltip } from '@percent/lemonade'
import { useTextOverflow } from '@percent/utility'
import { TruncatedListProps } from './truncated-list.types'
import styles from './truncated-list.module.scss'

export function TruncatedList({
  items,
  emptyText = 'N/A',
}: TruncatedListProps) {
  const textRef = useRef<HTMLSpanElement>(null)
  const isOverflowing = useTextOverflow(textRef)

  if (items.length === 0) {
    return <>{emptyText}</>
  }

  const allText = items.join(', ')
  const showOverflow = isOverflowing && items.length > 1

  return (
    <>
      <span
        ref={textRef}
        className={styles.text}
        aria-hidden={showOverflow || undefined}
      >
        {allText}
      </span>
      {showOverflow && (
        <span className={styles.overflowContainer}>
          {items[0]},{' '}
          <Tooltip content={allText}>
            <span className={styles.moreCount}>+{items.length - 1}</span>
          </Tooltip>
        </span>
      )}
    </>
  )
}
